import { priceHighlightTpl } from '../housing/housingTpl';
import { merchandisingBannerTpl } from '../../components/merchandising/merchandising';

export const housings = {
  init() {
    const mainSelector = '.js-housings';

    $(document).on('click', '.js-trigger-specials', (e) => {
      $(e.currentTarget).closest(mainSelector).find('.js-tabs .tab[data-tabcode="SPECIALS"]').trigger('click');
    }).on('click', mainSelector + ' .js-gb-cta .buttonContainer:first', (e) => {
      Tracking.dataLayerPush({
        clickCode: 'clickAccommodationCTA',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: 'Accommodation section',
        gaLabel: $(e.currentTarget).text().trim(),
        event: 'clickCTA'
      });
    }).on('click', mainSelector + ' .js-housing', (e) => {
      Tracking.dataLayerPush({
        clickCode: 'clickAccommodationBlock',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: 'Click on accommodation block button',
        gaLabel: $(e.currentTarget).find('.housing-name').text().trim(),
        gaValue: 1
      });
    });
  },

  getHousingData: () => {
    let ajaxParams = {
      c: SEARCH_SCRIPTS.COLLECTION,
      univers: GLOBAL_SCRIPTS.UNIVERS,
      language: GLOBAL_SCRIPTS.LANGUAGE_CODE,
      market: GLOBAL_SCRIPTS.MARKET_CODE,
      token: GLOBAL_SCRIPTS.SEARCH_TOKEN,
      type: 'PRODUCT_COTTAGES',
      item: SEARCH_SCRIPTS.PRODUCT_CODE,
      _controller: SEARCH_SCRIPTS.PAGETYPE.toLowerCase(),
      group: 'category',
      currency: GLOBAL_SCRIPTS.CURRENCY_CODE,
      accreditation: GLOBAL_SCRIPTS.ACCREDITATION,
      accreditationGroup: GLOBAL_SCRIPTS.ACCREDITATION_GROUP,
      cacheuser: GLOBAL_SCRIPTS.CACHE_USER,
      page: 1,
      nb: 30,
      sort: 'popularity',
      displayPrice: 'default',
      dayType: 'day',
      asc: 'asc',
      dateuser: 1,
      'option[formats_results]': '500x375',
      'option[formats_filters]': '566x250',
      'option[defaultDate]': 1,
      'facet[DATE]': SEARCH_SCRIPTS.DATE_SELECTED,
      'facet[DATEEND]': SEARCH_SCRIPTS.DATE_END_SELECTED,
      'facet[HOUSINGCATEGORY][]': [],
      'facet[MULTIPARTICIPANTS][0][adult]': SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].ADULTS_SELECTED,
      'facet[MULTIPARTICIPANTS][0][senior]': SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].SENIORS_SELECTED,
      'facet[MULTIPARTICIPANTS][0][pet]': SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].PETS_SELECTED,
      'facet[MULTIPARTICIPANTS][0][ages]': SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].AGES_SELECTED,
      'facet[COUNTRYSITE][]': 'l2_' + SEARCH_SCRIPTS.PRODUCT_CODE,
      'country_site_referer[]': 'l2_' + SEARCH_SCRIPTS.PRODUCT_CODE,
      referer: document.referrer.split('?')[0]
    };

    if (SEARCH_SCRIPTS.TOTALCOTTAGE === 2) {
      ajaxParams['facet[MULTIPARTICIPANTS][1][adult]'] = SEARCH_SCRIPTS.MULTIPARTICIPANTS[1].ADULTS_SELECTED;
      ajaxParams['facet[MULTIPARTICIPANTS][1][senior]'] = SEARCH_SCRIPTS.MULTIPARTICIPANTS[1].SENIORS_SELECTED;
      ajaxParams['facet[MULTIPARTICIPANTS][1][pet]'] = SEARCH_SCRIPTS.MULTIPARTICIPANTS[1].PETS_SELECTED;
      ajaxParams['facet[MULTIPARTICIPANTS][1][ages]'] = SEARCH_SCRIPTS.MULTIPARTICIPANTS[1].AGES_SELECTED;
      ajaxParams['option[multicottage][nb]'] = 2;
    }

    const deferred = $.Deferred();

    genericAjaxCall({
      ajaxUrl: GLOBAL_SCRIPTS.URL_BASE_API + 'results',
      ajaxParams: ajaxParams,
      successCallback: callbackDatas => {
        if (callbackDatas && callbackDatas.status === 'success') {
          $('.housing').each((_index, housing) => {
            const housingsTwigComfortLevel = housing.dataset.housingcomfortlevel;
            if (Object.prototype.hasOwnProperty.call(callbackDatas.results.results, housingsTwigComfortLevel)) {
              const product_datas = callbackDatas.results.results[housingsTwigComfortLevel];
              let detailCottagePrice = priceHighlightTpl({
                product_datas: product_datas,
                labelNew: GLOBAL_SCRIPTS.WORDINGS_CROSSSELL.label_new,
                labelRenovated: GLOBAL_SCRIPTS.WORDINGS_CROSSSELL.label_renovated,
                early_booking_label: GLOBAL_SCRIPTS.WORDINGS_CROSSSELL.early_booking_label,
                last_minute_label: GLOBAL_SCRIPTS.WORDINGS_CROSSSELL.last_minute_label,
                participants: {
                  children: SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].AGES_SELECTED.length,
                  senior: SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].SENIORS_SELECTED,
                  adult: SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].ADULTS_SELECTED,
                  pet: SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].PETS_SELECTED
                }
              });
              $('.housing[data-housingcomfortlevel=' + housingsTwigComfortLevel + ']').find('.housing-foot').html(detailCottagePrice).removeClass('mainLink');
              /* get all params */
              let housingType = '';
              if (product_datas.housing.comfortLevel.ownerCode.indexOf('CONFORT') !== -1) {
                housingType = product_datas.housing.comfortLevel.name.toUpperCase();
              } else if (product_datas.housing.comfortLevel.ownerCode.indexOf('PREMIUM') !== -1) {
                housingType = product_datas.housing.comfortLevel.name.toUpperCase();
              } else if (product_datas.housing.comfortLevel.ownerCode.indexOf('VIP') !== -1) {
                housingType = product_datas.housing.comfortLevel.name.toUpperCase();
              } else {
                housingType = housingsTwigComfortLevel.replace('-', '');
              }

              const housingCategoryParam = '?facet[HOUSINGCATEGORY][]=' + housingType;
              const dateParam = !!SEARCH_SCRIPTS.DATE_SELECTED ? '&facet[DATE]=' + SEARCH_SCRIPTS.DATE_SELECTED : '';
              const dateEndParam = !!SEARCH_SCRIPTS.DATE_END_SELECTED ? '&facet[DATEEND]=' + SEARCH_SCRIPTS.DATE_END_SELECTED : '';
              const seniorParam = '&facet[MULTIPARTICIPANTS][0][senior]=' + ((typeof callbackDatas.results.selected.multiparticipants[0].senior !== 'undefined') ? callbackDatas.results.selected.multiparticipants[0].senior.code : 0);
              const adultsParam = '&facet[MULTIPARTICIPANTS][0][adult]=' + ((typeof callbackDatas.results.selected.multiparticipants[0].adult !== 'undefined') ? callbackDatas.results.selected.multiparticipants[0].adult.code : 0);
              const petsParam = '&facet[MULTIPARTICIPANTS][0][pet]=' + ((typeof callbackDatas.results.selected.multiparticipants[0].pet !== 'undefined') ? callbackDatas.results.selected.multiparticipants[0].pet.code : 0);
              const senior2Param = '&facet[MULTIPARTICIPANTS][1][senior]=' + ((callbackDatas.results.selected.multiparticipants.length > 1 && typeof callbackDatas.results.selected.multiparticipants[1].senior !== 'undefined') ? callbackDatas.results.selected.multiparticipants[1].senior.code : 0);
              const adults2Param = '&facet[MULTIPARTICIPANTS][1][adult]=' + ((callbackDatas.results.selected.multiparticipants.length > 1 && typeof callbackDatas.results.selected.multiparticipants[1].adult !== 'undefined') ? callbackDatas.results.selected.multiparticipants[1].adult.code : 0);
              const pets2Param = '&facet[MULTIPARTICIPANTS][1][pet]=' + ((callbackDatas.results.selected.multiparticipants.length > 1 && typeof callbackDatas.results.selected.multiparticipants[1].pet !== 'undefined') ? callbackDatas.results.selected.multiparticipants[1].pet.code : 0);

              let agesParam = '';
              if (typeof callbackDatas.results.selected.multiparticipants[0].ages !== 'undefined') {
                callbackDatas.results.selected.multiparticipants[0].ages.map(agesArray => {
                  return agesParam += '&facet[MULTIPARTICIPANTS][0][ages][]=' + agesArray.code;
                });
              }

              let ages2Param = '';
              if (callbackDatas.results.selected.multiparticipants.length > 1 && typeof callbackDatas.results.selected.multiparticipants[1].ages !== 'undefined') {
                callbackDatas.results.selected.multiparticipants[1].ages.map(agesArray => {
                  return ages2Param += '&facet[MULTIPARTICIPANTS][1][ages][]=' + agesArray.code;
                });
              }

              let urlparams = housingCategoryParam + dateParam + dateEndParam + adultsParam + seniorParam + agesParam + petsParam;
              if (SEARCH_SCRIPTS.TOTALCOTTAGE === 2) urlparams += adults2Param + senior2Param + ages2Param + pets2Param + '&option[multicottage][nb]=2';

              $('.housing[data-housingcomfortlevel=' + housingsTwigComfortLevel + ']').attr('data-urlparams', urlparams);
            } else {
              let detailCottagePrice = priceHighlightTpl({
                product_datas: false,
                labelNew: GLOBAL_SCRIPTS.WORDINGS_CROSSSELL.label_new,
                labelRenovated: GLOBAL_SCRIPTS.WORDINGS_CROSSSELL.label_renovated,
                early_booking_label: GLOBAL_SCRIPTS.WORDINGS_CROSSSELL.early_booking_label,
                last_minute_label: GLOBAL_SCRIPTS.WORDINGS_CROSSSELL.last_minute_label,
                participants: {
                  children: SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].AGES_SELECTED.length,
                  senior: SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].SENIORS_SELECTED,
                  adult: SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].ADULTS_SELECTED,
                  pet: SEARCH_SCRIPTS.MULTIPARTICIPANTS[0].PETS_SELECTED
                }
              });
              $('.housing[data-housingcomfortlevel=' + housingsTwigComfortLevel + ']').removeClass('js-postParams').addClass('cursorNoLink').removeAttr('href').find('.housing-foot').html(detailCottagePrice).removeClass('mainLink');
            }
          });

          $('.js-housings .seeMore-Container').after('<div class="js-articleMessage u-Hidden"></div>');

          const articleMessageView = new ArticleMessageView({
            model: window.model,
            tpl: merchandisingBannerTpl,
            appendDatas: true,
            eltSelector: '.js-articleMessage',
            callback: ['slider:init', 'search:resultList:initFancyMerchOffer', 'heightEqualizer:reset'],
            callbackParam: ['.js-merchOffer-slider', '', '']
          });
        }

        // Refresh visual stuff
        if ($('.housings-elem[data-tabcode="COTTAGE"]').find('.housing').length > 3) {
          dispatcher.trigger('lazyload:update');
        }

        deferred.resolve();
      },
      abortable: true,
      type: 'GET',
      dataType: 'json'
    });

    return deferred.promise();
  }
};